import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Table, Spin, message } from "antd";
import Rendertable from "./Rendertable";
import { getSpecificService } from "../../../../actions/Appointment/serviceAction";

const ScheduleList = ({ id, schedule = [] }) => {
    const [data, setData] = useState(schedule);
    console.log("Awsome Data",data);
  
    useEffect(() => {
      setData(schedule);
    }, [schedule]);
    console.log("Awsome Data",schedule);
  
    return (
      <div>
        {data.length === 0 ? (
          <p>No schedules available.</p>
        ) : (
          <Rendertable List={data} />
        )}
      </div>
    );
  };

export default connect(null, { getSpecificService })(ScheduleList);
